// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'staging',
  urls: {
    source: 'http://localhost:4203',
    url: 'http://localhost:4203',
    module: 'backoffice',
    default_role: 'staff',
    gtagID: 'UA-3750617-20',
    crispID: '',
    sentryDsn: 'https://380cfcc50b1f4c93a4b1e93a8786ef84@o315478.ingest.sentry.io/1795986',
    languages: ['fr'],
    defaultLanguage: 'fr',
  },
  backofficeUrl: 'https://manage.lingueo.com',
  base_server: 'http://localhost:8001',
  server: 'http://localhost:8001/api/v1/',
  ws_server: 'wss://api.recurring.staging.lingueo.fr/ws/',
  auth: 'http://localhost:8001/api/v1/auth/',
  me: 'http://localhost:8001/api/v1/me/',
  media: 'http://localhost:8001/media/',
  static: 'http://localhost:8001/static/',
  salesforce_server: 'https://lingueo--staging2.sandbox.lightning.force.com',
  application_id: 'MX6xlCV4G5at4r31biAN9UG7VyrHggCrUHigyBY1TnrXhqak1xZWLSHETIoAiG9SYDZQqkwFRuUgM39zedn34Kh0itVCX3bfdnJFTjwH0ThUOdbjZqjl6709gXskESpD',
  client_id: 'fHJJ2cPFjzgRkb6ei3mFCLuC6KaLSuySWJbN1abz',
  test: 'fake',
  default_teacher_site: 'http://localhost:8001/api/v1/sites/3/',
  default_admin_site: 'http://localhost:8001/api/v1/sites/4/',
  default_student_site: 'http://localhost:8001/api/v1/sites/2/',
  default_event_rule: 'http://localhost:8001/api/v1/rules/3/',
  documents: '/api/v1/documents/',
  calendar_export: '/api/v1/calendar/export/',
  // maxFileSize: 2605699,
  maxFileSize: 262144000,
  fileSizeAlert: 'Merci de bien vouloir télécharger un document de moins de 26 mo',
  aiServer: 'https://staging.api.elate.lingueo.com/',
  stripePublicKey: 'pk_test_51Nb1VFD23W5cnICr9qS1yGiq7Q4wOQgMZChICIhKGh3PQh4lCekXuI24elbjpGFcI1DgffxrjXQGNhhn09urDcRa00bh7lKDEV',
};
